<template>
  <div id="exhibition-container">
    <slot name="banner" />
    <div class="exhibition-content">
      <div>
        <Loader
          v-if="isLoading"
          :style="{
            'padding-top': '20px'
          }"
          is-loading
        />
        <div
          v-else-if="displayForm"
          :style="{
            'padding-top': '20px'
          }"
        >
          <HubSpotContactForm
            v-if="!isLinkingLabel"
            :message="activationMessage"
            :form-id="formId"
            :portal-id="portalId"
            :region="region"
            :has-badge-number-input="hasBadgeNumberInput"
            :trade-show-name="tradeShowName"
            :form-data-constructor="formDataConstructor"
            @submitted="(formData) => activateLabel(formData)"
          />
          <Loader
            v-else
            is-loading
          />
        </div>
        <div
          v-else-if="displayTracking"
          class="tracking-screen-wrapper"
        >
          <TrackingScreen
            ref="trackingScreen"
            :ble-id="bleId"
            :asset-id="assetId"
            :t="token"
            :top-offset="58"
          />
        </div>
      </div>
      <ErrorMessage
        v-if="errorMessage"
        :error-message="errorMessage"
      />
    </div>
  </div>
</template>
<script>
import nbIotAuth from '../../../mixins/auth/nb-iot-auth';
import HubSpotContactForm from '../../molecules/marketing/hubspot-contact-form';
import ErrorMessage from '../../atoms/message/error-message';
import Loader from '../../atoms/loader/loader';
import TrackingScreen from '../nb-iot/tracking-screen';

export default {
  name: 'ExhibitionContainer',
  components: {
    HubSpotContactForm,
    ErrorMessage,
    Loader,
    TrackingScreen,
  },
  mixins: [nbIotAuth],
  props: {
    bleId: { type: String, required: true },
    assetId: { type: String, required: true },
    token: { type: String, default: '' },
    formId: { type: String, required: true },
    portalId: { type: String, required: true },
    region: { type: String, default: 'eu1' },
    activationMessage: { type: String, default: 'To activate your label, please fill out the form below' },
    assetNameConstructor: { type: Function, default: null },
    hasBadgeNumberInput: { type: Boolean, default: false },
    formDataConstructor: { type: Function, default: null },
    tradeShowName: { type: String, default: '' },
  },
  data() {
    return {
      isLoading: true,
      isLinkingLabel: false,
      componentErrorMessage: '',
    };
  },
  computed: {
    errorMessage() { return this.$store.state.nbIot.errorMessage || this.componentErrorMessage; },
    isLoadingData() { return this.$store.state.nbIot.isLoading; },
    nbIotData() { return this.$store.state.nbIot.data; },
    hasData() {
      return !this.errorMessage && !this.isLoadingData && !!this.nbIotData;
    },
    requiresActivationData() {
      return !!this.nbIotData && this.nbIotData.requiresActivationData;
    },
    displayForm() {
      return this.requiresActivationData;
    },
    displayTracking() {
      return !!this.hasData && !this.nbIotData.requiresActivationData;
    },
  },
  watch: {
    isLoadingData() {
      if (!this.isLoadingData || this.requiresActivationData) {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch(
        'nbIot/getNbIotAsset',
        {
          token: this.token,
          bleId: this.bleId,
          createIfNotExists: this.isNfcTap,
          forceLoading: true,
        },
      );
    },
    async activateLabel(formData) {
      this.isLinkingLabel = true;
      console.log('Activating label with form data:', formData, this.hasBadgeNumberInput);
      try {
        await this.$store.dispatch(
          'nbIot/activateNbIotLabel',
          {
            token: this.token,
            name: !this.hasBadgeNumberInput || typeof this.assetNameConstructor === 'function'
              ? this.constructAssetName(formData)
              : formData.badgeNumber,
            bleId: this.bleId,
          },
        );
        await this.getData(); // Refresh data to get updated status
      } catch (error) {
        this.componentErrorMessage = error.message;
      } finally {
        this.isLinkingLabel = false;
      }
    },
    constructAssetName(formData) {
      console.log('constructAssetName formData:', formData);
      if (this.assetNameConstructor && typeof this.assetNameConstructor === 'function') {
        return this.assetNameConstructor(formData);
      }
      if (!formData || !formData.firstname || !formData.company) {
        throw new Error('Form data is missing required fields: firstname and company');
      }
      return `${formData.firstname} (${formData.company})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.exhibition-content {
  margin-top: 60px;
}
.tracking-screen-wrapper {
  padding-top: 1px;
}
</style>
<style lang="scss">
#exhibition-container {
  font-family: Helvetica-Neue;
}
</style>
